var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderOpenAngled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12324_64118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.94 11.8893C23.8267 11.6326 23.5767 11.4693 23.3033 11.4693H20.9733V7.37594C20.9733 6.53927 20.3 5.8626 19.47 5.8626H8.93667V4.34927C8.93667 3.5126 8.26333 2.83594 7.43333 2.83594H1.50333C0.673333 2.83594 0 3.5126 0 4.34927V20.6693H0.0566667C0.0633333 20.6959 0.0666667 20.7193 0.0766667 20.7459C0.19 21.0026 0.44 21.1659 0.713333 21.1659H16.0667C16.2667 21.1659 16.4567 21.0793 16.59 20.9259L23.8233 12.6526C24.0067 12.4426 24.05 12.1426 23.94 11.8893ZM1.50333 4.34594H7.43333V7.3726H19.4667V11.4659H7.95C7.75 11.4659 7.56 11.5526 7.42667 11.7059L1.50333 18.4793V4.34594ZM15.7533 19.7426H2.27333L8.26333 12.8926H21.7433L15.7533 19.7426Z",
    fill: "#474747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12324_64118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9998,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpenAngled);
export default __webpack_public_path__ + "static/media/folder-open-angled.23560756cb9552d290704840e7e9c2bd.svg";
export { ForwardRef as ReactComponent };